import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["alt", "src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["alt", "src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'benefitsCasting',
  props: {
    plList: {},
    BenefitsCollection: {},
    leftImage: {},
    h3Title: {},
    pTitle: {},
    rightImage: {},
    leftSpan: { default: 2 },
    span: { default: 14 },
    rightSpan: { default: 8 },
    lineHeight: { default: 1.7 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      class: "content",
      gutter: 30,
      style: _normalizeStyle({ 'line-height': _ctx.lineHeight })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: _ctx.leftSpan,
          lg: _ctx.leftSpan,
          xl: _ctx.leftSpan
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: _ctx.leftImage.alt,
              src: _ctx.leftImage.imageUrl
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["md", "lg", "xl"]),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: _ctx.span,
          lg: _ctx.span,
          xl: _ctx.span
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", null, _toDisplayString(_ctx.h3Title), 1),
            (_ctx.plList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plList, (pl, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("p", null, _toDisplayString(pl.pTItle), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pl.liList, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.pTitle), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BenefitsCollection, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["md", "lg", "xl"]),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: _ctx.rightSpan,
          lg: _ctx.rightSpan,
          xl: _ctx.rightSpan
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: _ctx.rightImage.alt,
              src: _ctx.rightImage.imageUrl
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["md", "lg", "xl"])
      ]),
      _: 1
    }, 8, ["style"]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
  ], 64))
}
}

})